<script lang="ts">
    import src from './svg/route-status-note.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    import { _ } from 'svelte-i18n';
    export let count: number = 0;
    export let showCount: boolean = true;
    export let scale: number = 1;
    export let title: string = '';
    let currentTitle: string = '';

    $: {
        currentTitle = title ? title : $_('route-realisation-notes', { values: { count: count } });
    }
</script>

<div class="container">
    <TemplateIcon {src} {scale} alt={currentTitle} hover={currentTitle} on:click />
    {#if showCount && count > 0}
        <span class="count">({count})</span>
    {/if}
</div>

<style>
    .container {
        display: flex;
        align-items: center;
    }
    .count {
        font-size: 80%;
    }
</style>
